// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box[data-v-5f8336ea] {\n  color: var(--magic-tertiary, #311261);\n  box-shadow: 0 0 0 2px var(--magic-tertiary, #311261);\n  border-radius: var(--magic-border-radius, 4px);\n}\n\n.question[data-v-5f8336ea] {\n  color: var(--magic-tertiary, #311261);\n}\n\n.answer[data-v-5f8336ea] {\n  color: var(--magic-tertiary, #311261);\n}", ""]);
// Exports
module.exports = exports;
